<div class="flex flex-col justify-center w-full mb-0">
  <div class="w-full
   bg-[url(https://media.7minutespourtoi.fr/cdn-7mnptoi-fr/assets/images/home/lets-meet/lets-meet-woman-top-mobile.webp)]
   md:bg-[url(https://media.7minutespourtoi.fr/cdn-7mnptoi-fr/assets/images/home/lets-meet/lets-meet-woman-top-2.webp)]
   bg-cover bg-no-repeat h-60 2xs:h-80 md:h-120 xl:h-140 2xl:h-200" >
  </div>

  <div class="w-full -mt-10 md:-mt-25 z-9991 h-30">
    <svg  preserveAspectRatio="none" class="h-full w-full" [attr.viewBox]="'0 0 ' + viewBoxWidth() + ' 80'" >
      <path d="M1440 0C1420.65 1.98063 1401.63 4.39522 1383.13 7.21039C1328.06 15.5928 1289.22 26.6347 1218.3 26.7904C1152.18 26.9351 1125.81 18.2819 1075.2 10.8675C970.671 -4.44715 853.208 -2.38492 750.021 12.2658C685.369 21.442 648.628 33.9637 564.556 31.7606C508.379 30.2881 472.24 20.6223 425.007 14.5283C327.225 1.91016 214.439 2.29219 115.489 13.8385C78.7325 18.1298 47.8366 24.4945 5.28672 25.3217C3.55166 25.355 1.77937 25.381 -0.0078125 25.4033V36H1439.99V0H1440Z"
            fill="#e63432"/>
    </svg>
  </div>
  <div class="w-full flex flex-col text-center items-center h-50 xl:h-65 bg-theme-red-110 -mt-17 md:-mt-17 z-9990">
    <div class="w-1/2 bg-[url(https://media.7minutespourtoi.fr/cdn-7mnptoi-fr/assets/images/home/lets-meet/lets-meet-buzz.svg)] bg-bottom bg-contain bg-no-repeat h-12 2xs:h-16 mt-5 -ml-80 2xs:-ml-100 sm:mt-8 lg:-ml-150 xl:-ml-170" ></div>
    <p class="font-theme-hallelujah text-white text-left -rotate-3 leading-10 md:leading-14 text-3xl 2xs:text-4xl lg:text-5xl xl:text-6xl -mt-5 2xs:-mt-10 lg:-mt-15 xl:-mt-10">One life. More love.<br />Let’s meet!</p>
    <div class="w-1/2 bg-[url(https://media.7minutespourtoi.fr/cdn-7mnptoi-fr/assets/images/home/lets-meet/lets-meet-flower.svg)] bg-top bg-contain bg-no-repeat h-12 2xs:h-16 ml-50 -mt-9 2xs:ml-75 " ></div>
  </div>
  <div class="w-full -mt-1 h-30 z-9991">
    <svg preserveAspectRatio="none" class="h-full w-full" [attr.viewBox]="'0 0 ' + viewBoxWidth() + ' 80'">
      <path d="M0.000366211 36C19.3541 34.0194 38.3652 31.6048 56.87 28.7896C111.938 20.4072 150.779 9.36534 221.7 9.20956C287.819 9.06491 314.187 17.7181 364.802 25.1325C469.329 40.4471 586.792 38.3849 689.979 23.7342C754.631 14.558 791.372 2.03627 875.444 4.23944C931.621 5.71193 967.76 15.3777 1014.99 21.4717C1112.77 34.0898 1225.56 33.7078 1324.51 22.1615C1361.27 17.8702 1392.16 11.5055 1434.71 10.6783C1436.45 10.645 1438.22 10.619 1440.01 10.5967V0H0.0078125V36H0.000366211Z"
            fill="#e63432"/>
    </svg>
  </div>
  <div class="w-full -mt-48 h-30 z-9992 ">
    <div class="  bg-[url(https://media.7minutespourtoi.fr/cdn-7mnptoi-fr/assets/images/logo-m-color.svg)] bg-contain bg-no-repeat
          bg-center h-40 w-full -mt-0 rotate-6
          sm:bg-right sm:w-1/2 sm:float-right
          sm:-mt-4 sm:mr-10 sm:h-40
          md:-mt-7 md:mr-10 md:h-65
          lg:-mt-17 lg:mr-25
          xl:h-70 xl:-mt-22 xl:mr-40 " ></div>
  </div>
  <div class="w-full flex bg-white -mt-10 ">
    <div class="w-full ml-auto mr-auto 2xl:w-[90rem] 2xl:mt-10 z-9990 h-320 2xs:h-280 lg:h-260 flex flex-row relative">
      <div class="absolute top-0 left-5 sm:left-[30%] flex flex-col mt-25 sm:mt-30 pr-1 z-9999">

        <h1 class="font-theme-source block text-3xl lg:text-4xl xl:text-4xl 2xl:text-5xl font-bold text-theme-black text-left">
          Le speed dating à Nantes qui prend<br/>le temps d'accepter tes nuances
        </h1>

        <h2 class="font-theme-source block text-theme-black text-lg md:text-xl lg:text-2xl text-left font-bold mt-8">
          À Nantes, l'amour se joue en 7 minutes
        </h2>
        <div class="font-theme-source block text-theme-black text-left text-sm xs-home:text-base 2xs:text-base lg:text-base mt-5 pr-0 2xs:pr-10 sm:pr-20 z-9999">
          <p class="mb-2">
            Entre l'effervescence du quartier Bouffay, l'élégance du secteur Graslin, les rives de l'Erdre et l'île de Nantes, la cité offre un éventail de décors propices aux belles connexions.
            Pourtant, lorsqu'on souhaite vivre une rencontre amoureuse à Nantes, il n'est pas toujours simple de dépasser les échanges virtuels pour provoquer un véritable face-à-face.
          </p>
          <p class="mb-2">
            Nos soirées de speed dating permettent aux célibataires nantais et à ceux de la métropole de se retrouver dans un cadre chaleureux et bienveillant. Que tu viennes du centre-ville,
            de Chantenay, de Doulon ou d'une commune voisine, tu peux participer seul(e), discuter pendant 7 minutes avec plusieurs personnes et, si le feeling est au rendez-vous, donner une suite à une belle histoire.
          </p>

        </div>

        <h3 class="font-theme-source block text-theme-black text-lg md:text-xl lg:text-2xl text-left font-bold mt-8">
          Notre philosophie : SLOW LIVING & FAST DATING !
        </h3>
        <div class="font-theme-source block text-theme-black text-left text-sm xs-home:text-base 2xs:text-base lg:text-base mt-5 pr-0 2xs:pr-10 sm:pr-20 z-9999">
          <p class="mb-2">(Re)prendre le temps de vivre et de savourer chaque instant, tout en sachant que tout passe vite, trop vite.</p>
          <p class="mb-2">Comme le chantait Françoise Hardy, on pense que le temps de l’amour, c’est un temps de l’aventure, un temps long et court...</p>
          <p>Alors, on t'offre des instants courts, mais intenses. Des rencontres sincères, loin des écrans et des faux-semblants, avec des célibataires qui te correspondent.</p>
          <p class="mt-10 w-full xs-home:w-[355px]">
            <app-lp-cta class="w-full block z-9999" text="Révèle ton profil amoureux (gratuit)" [routerLink]="['/love-profile']" color="green"></app-lp-cta>
          </p>
        </div>
        <div class="w-full">
          <p class="font-theme-hallelujah text-theme-red-110 text-xl mt-5 2xs:text-2xl 2xs:mt-10 -rotate-3 float-right pr-2 2xs:pr-10 sm:float-left sm:pr-0">Parce qu’aimer,<br/>c’est oser !</p>
        </div>
      </div>
      <div class="flex flex-row w-full relative">
        <div class="w-1/4 -ml-7 h-full bg-[url(https://media.7minutespourtoi.fr/cdn-7mnptoi-fr/assets/images/home/lets-meet/lets-meet-woman-left.svg)] bg-contain bg-[left_bottom] bg-no-repeat z-9991">
        </div>
        <div class="md:absolute w-full md:w-[100vw] 2xl:w-[85vw] 3xl:w-[80vw] -ml-8 2xs:-ml-16 md:ml-26 2xl:ml-48 3xl:ml-48 h-full
        bg-[url(https://media.7minutespourtoi.fr/cdn-7mnptoi-fr/assets/images/home/lets-meet/lets-meet-line-bottom.svg)]
        md:bg-[url(https://media.7minutespourtoi.fr/cdn-7mnptoi-fr/assets/images/home/lets-meet/lets-meet-line-bottom-big.svg)] bg-contain bg-[right_bottom] bg-no-repeat z-9990">
          <div class="w-[60px] h-[580px]
                2xs:w-[90px] 2xs:h-[460px]
                md:w-[120px] md:h-[470px]
                lg:w-[130px] lg:h-[370px]
                xl:w-[150px] xl:h-[390px]
                2xl:w-[175px] 2xl:h-[410px]
                3xl:w-[185px] 3xl:h-[430px]
                float-right mt-174 2xs:mt-164 md:mt-160 lg:mt-165 xl:mt-160 2xl:mt-155 3xl:mt-150 mr-5 2xs:mr-10 md:mr-35 lg:mr-35 xl:mr-45 2xl:mr-55 3xl:mr-65
                bg-[url(https://media.7minutespourtoi.fr/cdn-7mnptoi-fr/assets/images/home/lets-meet/lets-meet-flower-bottom.svg)] bg-contain bg-[right_bottom] bg-no-repeat">
          </div>
        </div>
      </div>
    </div>
  </div>


</div>
